import React from 'react';
import { formatCurrency } from 'util/formatters';

const DisplayAmount = ({
  className = '',
  amount = 0,
  useMoneySign = false
}) => {
  if (amount > 0) {
    return (
      <span className={`gx-displayamount-positive ${className}`}>
        {formatCurrency(amount, useMoneySign)}
      </span>
    );
  }

  if (amount < 0) {
    return (
      <span className={`gx-displayamount-negative ${className}`}>
        {formatCurrency(amount, useMoneySign)}
      </span>
    );
  }

  return (
    <span className={className}>{formatCurrency(amount, useMoneySign)}</span>
  );
};

export default DisplayAmount;
